import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "description"]

  connect() {
    this.updateDescription()
  }

  updateDescription() {
    const selectedOption = this.selectTarget.options[this.selectTarget.selectedIndex]
    const description = selectedOption.dataset.description || ""
    
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.textContent = description
      if (description) {
        this.descriptionTarget.classList.remove("hidden")
      } else {
        this.descriptionTarget.classList.add("hidden")
      }
    }
  }
}
